import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../loader';
import { NODE_STATES } from './utils';
import {getDevicesInumeble, getInmuebleOrDeviceNodes} from '../../store/fuse/dashboard';
import { getNodesPerCategory } from '../../store/fuse/monitoreo';
import NodesModal from './table/nodesModal';

const INDICATORS_PROPS = [
  {
    src_image: 'assets/images/header-indicators/inmuebles.png',
    color_section: 'blue-primary',
    name_section: 'Inmuebles',
    brightness: 0.8,
    contrast: 0.8,
  },
  {
    src_image: 'assets/images/header-indicators/device.png',
    color_section: 'blue-primary',
    name_section: 'Dispositivos',
    brightness: 0.8,
    contrast: 0.8,
  },
  {
    src_image: 'assets/images/header-indicators/availability.png',
    color_section: 'blue-primary',
    name_section: 'Disponibilidad',
    brightness: 1.9,
    contrast: 1.9
  },
  {
    src_image: 'assets/images/header-indicators/bandwidth.png',
    color_section: 'blue-primary',
    name_section: 'Ancho de Banda Entrada',
    brightness: 0.8,
    contrast: 0.8
  },
  {
    src_image: 'assets/images/header-indicators/bandwidth.png',
    color_section: 'blue-primary',
    name_section: 'Ancho de Banda Salida',
    brightness: 0.8,
    contrast: 0.8,
  },
];

function HeaderDashboard({ filtersSelected, redirect }) {
  const dispatch = useDispatch();
  const firstSection = useSelector((state) => state?.fuse?.dashboard?.dashboard?.firstSection);
  const { loading, errorDashboard } = useSelector((state) => state?.fuse?.dashboard);
  const metrics = useSelector((state) => state?.fuse?.dashboard?.dashboard?.metrics);
  const loadingNodes = useSelector((state) => state.fuse?.monitoreo?.loadingNodes);
  const nodesData = useSelector((state) => state?.fuse?.monitoreo?.nodes);

  const inmuebleDeviceNodes = useSelector((state) => state?.fuse?.dashboard?.dashboard?.indicators?.nodes);
  const inmuebleDeviceLoading = useSelector((state) => state?.fuse?.dashboard?.dashboard?.indicators?.loading);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const [open, setOpen] = useState(false);
  const [colorInmueble, setColorInmueble] = useState('');
  const [isInmuebleOrDevice, setIsInmuebleOrDevice] = useState(false);
  const [modalType, setModalType] = useState('node');
  const handleClose = () => setOpen(false);

  const handleClick = (index, color) => {
    let chosenMetric;
    let metricType = 'metric';
    setIsInmuebleOrDevice(false);
    setOpen(true);
    if (index === 0) {
      setIsInmuebleOrDevice(true);
      setModalType('inmueble');
      dispatch(getInmuebleOrDeviceNodes('inmuebles', color, filtersSelected));
      setColorInmueble(color)
      return;
    }
    if (index === 1) {
      setIsInmuebleOrDevice(true);
      setModalType('nodo');
      dispatch(getInmuebleOrDeviceNodes('dispositivos', color, filtersSelected));
      return;
    }
    if (index === 2) {
      chosenMetric = metrics.find((metric) => metric.metrica === 'Disponibilidad');
      setModalType('nodo');
    }
    if (index === 3) {
      chosenMetric = metrics.find((metric) => metric.metrica === 'Ancho Banda');
      metricType = 'anchobandaentrada';
      setModalType('interface');
    }
    if (index === 4) {
      chosenMetric = metrics.find((metric) => metric.metrica === 'Ancho Banda Subida');
      metricType = 'anchobandasalida';
      setModalType('interface');
    }
    dispatch(getNodesPerCategory(metricType, chosenMetric.id, color, filtersSelected));
  };

  return (
    <>
      {errorDashboard ? (
        <>
          <div className="flex mb-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Loader nameComponent="firstSection" nameLabel="Indicadores Generales" loader={loading?.loading} />
          </div>
        </>
      ) : (
        firstSection.length >= 1 && (
        <div className="flex m-10 rounded-lg mt-0 overflow-x-auto" style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}>
          {firstSection?.map((data, index) => (
            <div
              key={index}
              className="flex-grow my-24 mr-10 ml-5 card card-plain text-white card-section"
              style={{
              backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' ,
              color: darkMode ? 'white' : 'black',
            }}
            >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="flex w-full">
                <div className="w-1/3">
                  <img className="rounded-lg image-section" src={INDICATORS_PROPS[index].src_image} alt="card"
                    style={{
                      filter: darkMode ? `invert(2) brightness(${INDICATORS_PROPS[index].brightness || 1}) contrast(${INDICATORS_PROPS[index].contrast || 1})` : `invert(0) contrast(${INDICATORS_PROPS[index].contrast || 1})`,
                    }}/>
                    </div>
                    <div className="card-body w-2/3" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <span
                        className="font-bold uppercase"
                        style={{
                          width: '140px',
                          overflowWrap: 'break-word',
                          wordWwrap: 'break-word',
                          wordBreak: 'break-word',
                          fontSize: '13px',
                          color: darkMode ? 'white' : 'black',
                        }}
                      >
                        {INDICATORS_PROPS[index].name_section}
                      </span>
                      <div>
                        <h3 className="font-bold text-200">{data?.total}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="flex items-center justify-between card-font w-full">
                      <div className="pr-3">
                        <div className="percentage-data">
                          <div>
                            <div className="percentage-section">
                              <div
                                role="button"
                                aria-label="green-indicator-btn"
                                className="rounded-header-section"
                                onClick={() => handleClick(index, 'verde')}
                                onKeyDown={() => handleClick(index, 'verde')}
                                tabIndex={0}
                                style={{ background: NODE_STATES[2] }}
                              />{' '}
                              <div style={{ fontSize: '16px' }}>{`${data?.up}`} </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pr-3">
                        <div className="percentage-data">
                          <div>
                            <div className="percentage-section">
                              <div
                                role="button"
                                aria-label="yellow-indicator-btn"
                                className="rounded-header-section"
                                onClick={() => handleClick(index, 'amarillo')}
                                onKeyDown={() => handleClick(index, 'amarillo')}
                                tabIndex={0}
                                style={{ background: NODE_STATES[1] }}
                              />{' '}
                              <div style={{ fontSize: '16px' }}>{`${data?.warning}`} </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pr-3">
                        <div className="percentage-data">
                          <div>
                            <div className="percentage-section">
                              <div
                                role="button"
                                aria-label="yellow-indicator-btn"
                                className="rounded-header-section"
                                onClick={() => handleClick(index, 'rojo')}
                                onKeyDown={() => handleClick(index, 'rojo')}
                                tabIndex={0}
                                style={{ background: NODE_STATES[0] }}
                              />{' '}
                              <div style={{ fontSize: '16px' }}>{`${data?.down}`} </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      )}
      <NodesModal
        openModal={open}
        handleCloseModal={handleClose}
        loading={isInmuebleOrDevice ? inmuebleDeviceLoading : loadingNodes}
        nodesData={isInmuebleOrDevice ? inmuebleDeviceNodes : nodesData}
        filtersSelected={filtersSelected}
        colorInmueble={colorInmueble}
        redirectPath={redirect}
        type={modalType}
        setModalType={setModalType}
      />
    </>
  );
}
export default HeaderDashboard;
